export enum BankAccountMainTypeEnum {
    Checking = 1,
    Savings
}

export enum BankCardAuthStatus {
    New = 0, // 新提交
    Insufficient = 2, // 待补充信息
    Unaudited = 3, // 待审核
    Audited = 4, // 审核通过 （表示我们这边单方面认证通过）
    Authenticated = 6, // 认证通过 （表示第三方银行认证通过现只有银证和DDA -- 权限最高）
    AuditFail // 审核失败
}

export interface BankCardItemTypes {
    id: number;
    bankName: string; // 银行名称
    bankAccount: string; // 银行账号
    bankCountry: string;
    holderName: string;
    swiftCode?: string; // SWIFT Code
    clearingCode?: string; // ABA Routing Number
    holderCountry?: string; // 收款人国家/地区
    holderCityState?: string; // 收款人省/市/自治区
    holderHomeAddr?: string; // 收款人街道门牌号
    completed?: boolean; // 银行卡信息是否完整（完整才能入金）
    canEdit: boolean;
    canDelete: boolean;
    /**
     * 1: Checking
     * 2: Savings
     */
    bankAccountMainType?: BankAccountMainTypeEnum;
    status: BankCardAuthStatus;
    needAuthenticated: boolean;
}

/**
 * 银行卡来源
 * 用于添加或者修改银行卡
 * 如果source不为‘deposit_notice’或‘authentication‘则swiftCode,clearingCode,holderHomeAddr,holderCountry,holderCityState五个参数必需
 */
export type BankCardSourceType = 'deposit_notice' | 'authentication' | 'withdraw_manage';
